import React, { createContext, useState, useEffect } from 'react';
import Api from '../utils/Api';
/**
 * Contexte d'authentification de l'application.
 *
 * Ce composant permet de :
 * - stocker les informations de l'utilisateur connecté
 * - vérifier l'utilisateur au chargement de l'application
 * - gérer la connexion et la déconnexion
 * - rendre les données d'authentification accessibles
 *   dans toute l'application avec AuthContext
 *
 * Le token est conservé dans le sessionStorage et l'utilisateur
 * est normalisé pour assurer un format uniforme des données.
 *
 * Modifié par : Philippe-Vu Beaulieu
 * Date : 2026-04-16
 */
export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const normalizeUser = (payload) => {
    const currentUser = payload?.user ?? payload ?? {};
        return {
            ...currentUser,
            username: currentUser.username ?? currentUser.name ?? '',
            role: currentUser.role ?? currentUser.role_name ?? ''
        };
    };
    // Vérification au chargement de l'app
    useEffect(() => {
        const token = sessionStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }
        
        Api.defaults.headers.common.Authorization = `Bearer ${token}`;

        Api.get('/auth/current_user')
            .then((response) => {
                const normalizedUser = normalizeUser(response.data);
                setUser(normalizedUser);
            })
            .catch(() => {
                setUser(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const login = (token, username, role) => {
        sessionStorage.setItem('token', token);
        Api.defaults.headers.common.Authorization = `Bearer ${token}`;
        setUser({ username, role });
        Api.get('/auth/current_user')
            .then((response) => {
            const normalizedUser = normalizeUser(response.data);
                setUser(normalizedUser);
            })
            .catch(() => {
                setUser({ username, role });
            });
    };

    const logout = () => {
        sessionStorage.removeItem('token');
        delete Api.defaults.headers.common.Authorization;
        setUser(null);

        Api.post('/auth/logout').catch(() => {});
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                login,
                logout,
                loading
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};